import ContentfulAsset from '../reference-blocks/contentful-asset'

import generateRTFComponent from '.'

const TransformationStoryRTF = generateRTFComponent({
  ContentfulAsset,
})

export default TransformationStoryRTF
